import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, BORDER_RADIUS, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import {Button, ButtonBase} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import AddIcon from '@material-ui/icons/Add';
import {ColorActivityForm, ColorSubTitle, ColorWhite} from "src/styles/Colors";
import FormHelperText from "@material-ui/core/FormHelperText";
import {getInitialFiles} from "../../utils/ValueHelper";
import {cloneDeep, map} from "lodash";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import Typography from "@material-ui/core/Typography";
import TextView from "../commons/TextView";
import {FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import SingleFilePicker, {
  ACCEPTED_AUDIO_MIMES,
  ACCEPTED_IMAGE_MIMES,
  ACCEPTED_VIDEO_MIMES,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO,
  IMAGE_MAX_WIDTH_HEIGHT
} from "../commons/SingleFilePicker";
import FileHelper from "../../utils/FileHelper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {locString, SNACKBAR_AUTO_HIDE_DURATION} from "../commons/ViewHelper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {CTA_TITLES} from "../../constants/ApiConstants";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {SECTION_HEADER_BOTTOM_SPACE} from "src/js/components/commons/SectionHeaderView";

const useStyles = () => ({
  optionsWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  optionCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
    padding: 4,
    display: 'flex',
    flexDirection: 'row'
  },
});

const MAX_QUESTIONS_COUNT = 3;

class ManageReelSubPosts extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.maxVideoDuration = 60;
    this.maxAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxVideoDuration = activityData.mediaConfigs.maxSubPostVideoDuration;
      this.maxAudioDuration = activityData.mediaConfigs.maxSubPostAudioDuration;
    }
    this.maxDuration = Math.max(this.maxVideoDuration, this.maxAudioDuration);

    this.isSubPostReset = false;
    if (activityData.subPosts && activityData.subPosts.length > 0 && activityData.subPosts[0].id < 0) {
      activityData.subPosts = null;
      this.isSubPostReset = true;
    }

    let number = 1;
    const questions = [];
    if (activityData.subPosts && activityData.subPosts.length > 0) {
      activityData.subPosts.forEach((question) => {
        const mediaUrl = question.videoUrl || question.audioUrl || question.imageUrl;
        const mediaFiles = question.videoFiles || question.audioFiles || question.imageFiles;
        const mediaType = question.videoUrl ? FILE_TYPE_VIDEO : question.bgAudioFiles ? FILE_TYPE_AUDIO : FILE_TYPE_IMAGE;
        const mediaTUrl = question.videoTUrl;
        const isMediaDeleted = question.isVideoDeleted || question.isAudioDeleted || question.isImageDeleted;
        questions.push({
          number: number,
          id: question.id,
          title: question.title,
          link: question.link,
          linkText: question.linkText,
          videoUrl: question.videoUrl,
          videoFiles: question.videoFiles,
          audioUrl: question.audioUrl,
          audioFiles: question.audioFiles,
          imageUrl: question.imageUrl,
          imageFiles: question.imageFiles,
          mediaUrl: mediaUrl,
          mediaFiles: mediaFiles,
          isMediaDeleted: isMediaDeleted,
          initialMediaFiles: getInitialFiles(mediaFiles, mediaUrl, mediaType, mediaTUrl),
          section: {id: number, label: '#Post-'+ number +': '+ question.title, expand: true},
        });
        number++;
      });
    } else {
      questions.push(this.getNewQuestion(number));
    }

    this.state = {
      questions: questions,
      deleteQuestionIds: activityData.deleteSubPostIds || [],
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    if (this.isSubPostReset) {
      this.props.onDataUpdated(this.getData(true));
    }
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields) {
    this.setState(fields, () => {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        this.props.onDataUpdated(this.getData(true));
        this.timeoutHandler = null;
      }, 400);
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError, showButtonError = false) {
    const {activityData} = this.props;
    const {
      questions,
      deleteQuestionIds
    } = this.state;

    if (!excludeError) {
      if (!this.areQuestionsCorrect(showButtonError)) {
        this.setState({showValidationMsg: true, showButtonError});
        return false;
      }
    }
    const questionsL = [];
    const questionIds = [];
    questions.forEach((question) => {
      if ((question.mediaFiles && question.mediaFiles.length > 0) || question.mediaUrl
        || (question.title && question.title.trim().length > 0)
        || (question.link && question.link.trim().length > 0)
        || (question.linkText && question.linkText.trim().length > 0)) {
        // const questionL = cloneDeep(question);
        const questionL = {...question};
        let isVideoDeleted = false;
        let isAudioDeleted = false;
        let isImageDeleted = false;
        let videoUrl = questionL.videoUrl;
        let audioUrl = questionL.audioUrl;
        let imageUrl = questionL.imageUrl;
        let imageFiles = null;
        let videoFiles = null;
        let audioFiles = null;
        if (!questionL.mediaUrl) {
          videoUrl = null;
          audioUrl = null;
          imageUrl = null;
          isVideoDeleted = true;
          isAudioDeleted = true;
          isImageDeleted = true;
        }
        if (questionL.mediaFiles && questionL.mediaFiles.length > 0) {
          if (questionL.mediaFiles[0].type === FILE_TYPE_VIDEO) {
            videoFiles = questionL.mediaFiles;
          } else if (questionL.mediaFiles[0].type === FILE_TYPE_AUDIO) {
            audioFiles = questionL.mediaFiles;
          } else {
            imageFiles = questionL.mediaFiles;
          }
        }
        questionL.imageUrl = imageUrl;
        questionL.imageUrls = imageUrl ? [imageUrl] : null;
        questionL.imageFiles = imageFiles;
        questionL.imageDeleted = isImageDeleted;
        questionL.audioUrl = audioUrl;
        questionL.audioFiles = audioFiles;
        questionL.isAudioDeleted = isAudioDeleted;
        questionL.videoUrl = videoUrl;
        questionL.videoFiles = videoFiles;
        questionL.isVideoDeleted = isVideoDeleted;
        delete questionL.section;
        questionsL.push(questionL);
        questionIds.push('' + questionL.id);
      }
    });

    return {
      subPosts: questionsL,
      subPostIds: questionIds,
      deleteSubPostIds: deleteQuestionIds
    };
  }

  render() {
    const {
      showValidationMsg,
      showButtonError,
      questions,
    } = this.state;
    const {classes, isXS} = this.props;

    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        {questions.map((question, index) => this.getViewForQuestion(question, index))}

        {questions.length < MAX_QUESTIONS_COUNT ?
          <React.Fragment>
            <div>
              <Button
                size={isXS ? 'medium' : 'large'}
                variant={"outlined"}
                color="primary"
                startIcon={<AddIcon />}
                onClick={this.onAddNewQuestionClicked}>
                {<FormattedMessage id={'activity.addAnotherPost'} />}
              </Button>
            </div>
            {showValidationMsg && showButtonError && !this.areQuestionsCorrect(true) && <FormHelperText className={classes.helperError}><FormattedMessage id='activity.correctErrorSubPost' /></FormHelperText>}
          </React.Fragment>
          : null
        }
        <FieldSpace />

        {this.renderSnackBar()}
      </div>
    )
  }

  getViewForQuestion(question, questionIndex) {
    const {classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    const fieldWrapperSpace = isXS ? 16 : FIELD_SPACE;
    const fieldSpace = isXS ? 8 : 12;
    const mediaError = !question.mediaUrl && !question.mediaFiles;

    return (
      <div key={''+ question.id} className={classes.formActivity} style={{maxWidth: 600}}>
        {this.getSectionHeaderView(question, questionIndex)}
        {question.section.expand ?
          <div key={'sub'+ question.id} className={classes.viewColumnFullWidth}>
            <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
              <SingleFilePicker
                key={'SPF'+ question.id}
                required={false}
                hideDropzoneText={true}
                size={isXS ? 'xsmall' : 'small'}
                filesLimit={1}
                showPreviewsInDropzone={true}
                acceptedFiles={{...ACCEPTED_VIDEO_MIMES, ...ACCEPTED_IMAGE_MIMES}}
                maxFileSize={100*1024*1024}
                maxDuration={this.maxDuration}
                maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
                maxDurationMimes={{audio: this.maxAudioDuration, video: this.maxVideoDuration}}
                maxSizeMimes={{audio: 2*1024*1024, image: 20*1024*1024, video: 100*1024*1024}}
                aspectRatioMimes={{image: 1, video: 9/16}}
                aspectRatio={1}
                initialFiles={question.initialMediaFiles}
                onError={this.onErrorFiles}
                onChange={(files) => {
                  this.onChangeFiles(files, 'mediaUrl', question);
                }}
                onDelete={(file) => {
                  this.onDeleteFile(file, 'mediaUrl', question, questionIndex);
                }}
                error={showValidationMsg && mediaError}
              />
              {!isXS && showValidationMsg && mediaError ? <FormHelperText className={classes.helperError}>{locString('activity.reelMediaRequired')}</FormHelperText> : null}
              <FieldSpace vertical={isXS}/>

              <div className={classes.viewColumnFullWidthNoCenter}>
                <TextField
                  variant="filled"
                  fullWidth
                  multiline
                  rows={1}
                  rowsMax={8}
                  size="small"
                  type="text"
                  id={"title"+ questionIndex}
                  name={"title"}
                  label={<FormattedMessage id={'activity.reelTitle'} />}
                  InputProps={{disableUnderline: true}}
                  inputProps={{maxLength: 200}}
                  value={question.title}
                  style={{flex: 1}}
                  onChange={this.onChangeQuestion.bind(this, questionIndex)}
                />
                <FieldSpace />

                <div className={classes.flexRow}>
                  <FormControl
                    size="small"
                    fullWidth
                    variant="filled">
                    <InputLabel id="dropDown"><FormattedMessage id={'activity.subPostLinkText'} /></InputLabel>
                    <Select
                      labelId="dropDown"
                      required
                      id={"linkText"+ questionIndex}
                      name="linkText"
                      value={question.linkText}
                      disableUnderline={true}
                      onChange={this.onChangeQuestion.bind(this, questionIndex)}>
                      <MenuItem value="">
                        <TextView color={ColorSubTitle}>
                          <em><FormattedMessage id={'generic.none'} /></em>
                        </TextView>
                      </MenuItem>
                      {map(CTA_TITLES, (ctaTitle) => {
                        return (
                          <MenuItem key={ctaTitle.id} value={ctaTitle.id}>{<FormattedMessage id={ctaTitle.nameId} />}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                  <FieldSpace vertical={true}/>

                  <TextField
                    variant="filled"
                    fullWidth
                    size="small"
                    type="text"
                    id={"link"+ questionIndex}
                    name="link"
                    label={<FormattedMessage id='activity.subPostLink'/>}
                    InputProps={{disableUnderline: true}}
                    inputProps={{maxLength: 1000}}
                    value={question.link}
                    onChange={this.onChangeQuestion.bind(this, questionIndex)}
                  />
                </div>
              </div>
            </div>
            {isXS && showValidationMsg && mediaError ? <FormHelperText className={classes.helperError}>{locString('activity.reelMediaRequired')}</FormHelperText> : null}
          </div>
          : null
        }
        <FieldSpace multiplier={2}/>
      </div>
    );
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} />
    );
  }

  getSectionHeaderView(question, questionIndex) {
    const {classes, isXS} = this.props;
    const {questions} = this.state;
    const section = question.section;
    let isNotExpended = false;
    section.label = <FormattedMessage id={'activity.hashPostWithNumber'} values={{value: question.number}}/>
    if (!section.expand) {
      isNotExpended = true;
    }
    return (
      <div className={classes.flexColumnNoCenter}>
        <div className={classes.expandCollapseBar}>
          <ButtonBase disabled={true} className={classes.buttonBaseApp} onClick={this.onFormSectionToggle.bind(this, question)}>
            <div className={classes.flexRow}>
              <div className={classes.viewColumnFullWidthNoCenter}>
                <div className={classes.flexRow} style={{paddingBottom: SECTION_HEADER_BOTTOM_SPACE}}>
                  <TextView numberOfLines={2} variant={'body1'} color={'primary'} align={'left'} fontWeight={isNotExpended ? FontWeightRegular : FontWeightMedium}>
                    {section.labelId ?
                      <FormattedMessage id={section.labelId} />
                      : section.label
                    }
                  </TextView>
                </div>
                {section.subLabelId ?
                  <Typography color={'textSecondary'} variant={'caption'} align={'left'} style={{marginTop: -10, marginBottom: 8}}>
                    <FormattedMessage id={section.subLabelId} />
                  </Typography>
                  : null
                }
              </div>
              <Space vertical={16} />
            </div>
          </ButtonBase>
          {/*<Tooltip title={<FormattedMessage id={section.expand ? 'activity.collapseSubPost' : 'activity.expandSubPost'} />}>*/}
          {/*  <IconButton onClick={this.onFormSectionToggle.bind(this, question)}>*/}
          {/*    {section.expand ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />}*/}
          {/*  </IconButton>*/}
          {/*</Tooltip>*/}
          {/*<div style={{height: '100%', width: 1, backgroundColor: ColorBorder}} />*/}
          {/*<Tooltip title={<FormattedMessage id={'activity.moveUpSubPost'} />}>*/}
          {/*  <IconButton disabled={questionIndex === 0} onClick={this.onMoveUpSection.bind(this, question, questionIndex)}>*/}
          {/*    {<ArrowUpwardIcon />}*/}
          {/*  </IconButton>*/}
          {/*</Tooltip>*/}
          {/*<Tooltip title={<FormattedMessage id={'activity.moveDownSubPost'} />}>*/}
          {/*  <IconButton disabled={questionIndex === questions.length - 1} onClick={this.onMoveDownSection.bind(this, question, questionIndex)}>*/}
          {/*    {<ArrowDownwardIcon />}*/}
          {/*  </IconButton>*/}
          {/*</Tooltip>*/}
          {/*<Tooltip title={<FormattedMessage id={'activity.removeSubPost'} />}>*/}
          {/*  <IconButton size={'small'} onClick={this.onDeleteSection.bind(this, question, questionIndex)} className={classes.imageIconButton}>*/}
          {/*    {<ImageIcon src={require('src/images/ic_delete_bg.png')} width={38} height={38} />}*/}
          {/*  </IconButton>*/}
          {/*</Tooltip>*/}
        </div>
      </div>
    );
  }

  onFormSectionToggle = (question) => {
    const {questions} = this.state;
    question.section.expand = !question.section.expand;
    this.setState({questions: questions});
  }

  onDeleteSection = (question, questionIndex) => {
    let {questions, deleteQuestionIds} = this.state;
    if (question.id) {
      deleteQuestionIds.push(question.id);
    }
    questions.splice(questionIndex, 1);
    if (questions.length === 0) {
      questions.push(this.getNewQuestion(1));
    }

    // reset question no
    let number = 1;
    questions.forEach((question) => {
      question.number = number;
      question.section.id = number;
      number++;
    });
    this.updateState({questions, deleteQuestionIds});
  }

  onMoveUpSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex > 0) {
      const prevQuestion = questions[questionIndex - 1];
      const number = question.number;
      const sectionId = question.section.id;
      question.number = prevQuestion.number;
      question.section.id = prevQuestion.section.id;
      prevQuestion.number = number;
      prevQuestion.section.id = sectionId;

      questions[questionIndex - 1] = question;
      questions[questionIndex] = prevQuestion;
    }
    this.updateState({questions: questions});
  }

  onMoveDownSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex < questions.length - 1) {
      const nextQuestion = questions[questionIndex + 1];
      const number = question.number;
      const sectionId = question.section.id;
      question.number = nextQuestion.number;
      question.section.id = nextQuestion.section.id;
      nextQuestion.number = number;
      nextQuestion.section.id = sectionId;

      questions[questionIndex + 1] = question;
      questions[questionIndex] = nextQuestion;
    }
    this.updateState({questions: questions});
  }

  getNewQuestion(number) {
    const questionId = number - 1;
    return {
      id: -questionId,
      number: number,
      title: '',
      mediaUrl: null,
      mediaFiles: null,
      isMediaDeleted: false,
      initialMediaFiles: [],
      section: {id: number, label: '#Post-'+ number +': ', expand: true},
    };
  }

  onAddNewQuestionClicked = () => {
    const data = this.getData(false, true);
    if (data) {
      const {questions} = this.state;
      questions.push(this.getNewQuestion(questions.length + 1));
      this.updateState({questions});
    }
  };

  areQuestionsCorrect(fromAddNew = false) {
    const {questions} = this.state;
    let isCorrect = true;
    if (questions && questions.length > 0) {
      let index = 0;
      questions.forEach((question) => {
        if (!this.isQuestionCorrect(question, index, questions.length, fromAddNew)) {
          isCorrect = false;
        }
        index++;
      });
    }
    return isCorrect;
  }

  isQuestionCorrect(question, index, length, fromAddNew) {
    let isCorrect = true;
    if ((!question.mediaUrl && (!question.mediaFiles || question.mediaFiles.length === 0))) {
      if (fromAddNew
        || (question.title && question.title.trim().length > 0)
        || (question.link && question.link.trim().length > 0)
        || (question.linkText && question.linkText.trim().length > 0)) {
        isCorrect = false;
      }
    }
    if (!isCorrect) {
      question.section.expand = true;
    }
    return isCorrect;
  }

  onChangeQuestion = (questionIndex, event) => {
    const {questions} = this.state;
    let value = event.target.value;
    if (event.target.name === 'title') {
      value = value.replace("\n", " ");
    }
    questions[questionIndex][event.target.name] = value;
    this.updateState({questions: questions, showValidationMsg: false});
  };

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id, question) {
    const {questions} = this.state;
    const {
      mediaUrl,
    } = question;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    question[keyImageUrl] = lFileUrl;
    question[keyImageFiles] = lFiles;
    this.updateState({questions: questions, showValidationMsg: false});
  }

  onDeleteFile(file, id, question, questionIndex) {
    const {questions} = this.state;
    const {
      mediaUrl,
      mediaFiles,
    } = question;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    question[keyImageUrl] = lFileUrl;
    question[keyImageFiles] = lFiles;
    question[keyIsImageDeleted] = true;
    this.onDeleteSection(question, questionIndex);
    // this.updateState({questions: questions, showValidationMsg: false});
  }

}

ManageReelSubPosts.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageReelSubPosts.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageReelSubPosts))
);
